// src/config.js
const AppConfig = {
    title: "failed….",
    paragraph: "Loading corrupted…",
    img: "https://i.postimg.cc/zBvTx8kx/IMG-6877.jpg",
    url: "failed",
    id: "6261026"
};

export default AppConfig;